export const inventoryEndpoints = {
  // Inventory - Warehouses
  warehouse: {
    getAll: (branchId: number) => `/api/Warehouse/GetAllWarehouses?branchId=${branchId}`,
    getById: (id: number) => `/api/Warehouse/GetWarehouseById/${id}`,
    create: '/api/Warehouse/CreateWarehouse',
    update: '/api/Warehouse/UpdateWarehouse',
    delete: (id: number) => `/api/Warehouse/DeleteWarehouse/${id}`,
  },

  // Inventory - Item Categories
  itemCategories: {
    getAll: (branchId: number) => `/api/ApiItemCategories/GetAllItemCategory/${branchId}`,
    getSubCategoriesByCategoryId: (catId: number) => `/api/ApiItemCategories/GetItemSubCategoryByCategoryId/${catId}`,
    formSave: '/api/ApiItemCategories/FormSave',
  },

  // Inventory - Items
  items: {
    getAll: (branchId: number, pageNumber: number, pageSize: number) =>
      `/api/ApiItem/GetAllItems/${branchId}/${pageNumber}/${pageSize}`,
    getById: (id: number, branchId: number) => `/api/ApiItem/GetItemsById/${id}/${branchId}`,
    getAllItemCategory: (branchId: number) => `/api/ApiItemCategories/GetAllItemCategory/${branchId}`,
    getAllItemSubCategory: (branchId: number) => `/api/ApiItem/GetAllItemSubCategory/${branchId}`,
    getMaterialTypesLookups: '/api/ApiItem/GetMaterialTypesLookups',
    getMaterialUOMsLookups: '/api/ApiItem/GetMaterialUOMsLookups',
    getPurchaseTaxes: (branchId: number) => `/api/ApiItem/GetPurchaseTaxes?branchId=${branchId}`,
    getSalesTaxes: (branchId: number) => `/api/ApiItem/GetSalesTaxes?branchId=${branchId}`,
    save: '/api/ApiItem/Save2',
    update: '/api/ApiItem/Update2',
  },

  // Inventory - Item Batches
  batchItem: {
    getAll: (branchId: number, pageNumber: number, pageSize: number) =>
      `/api/BatchItem/GetAllBatchItems?branchId=${branchId}&pageNumber=${pageNumber}&pageSize=${pageSize}`,
    getById: (id: number) => `/api/BatchItem/GetBatchItemById/${id}`,
    /** Warehouse lines for a batch (edit form opening stock grid) */
    getWhItems: (batchId: number) => `/api/BatchItem/GetWhItems?batchId=${batchId}`,
    save: '/api/BatchItem/Save',
    update: '/api/BatchItem/Update',
  },

  /** Inventory dispatch / transfer-branch (Swagger: InventoryTransferBranch) */
  inventoryTransferBranch: {
    getWarehousesByBranchId: (branchId: number) => `/api/InventoryTransferBranch/GetWarehousesByBranchId?branchId=${branchId}`,
    getItemsByWarehouse: (whId: number) => `/api/InventoryTransferBranch/GetItemsByWarehouse/${whId}`,
    getBatchesByWarehouseAndItem: (whId: number, itemId: number) =>
      `/api/InventoryTransferBranch/GetBatchesByWarehouseAndItem?whId=${whId}&itemId=${itemId}`,
    getItemDetails: (whId: number, itemId: number, bId: number) =>
      `/api/InventoryTransferBranch/GetItemDetails?whId=${whId}&itemId=${itemId}&bId=${bId}`,
    getAllInventoryTransfers: (branchId: number, pageSize: number, pageNumber: number) =>
      `/api/InventoryTransferBranch/GetAllInventoryTransfers?branchId=${branchId}&pageSize=${pageSize}&pageNumber=${pageNumber}`,
    getById: (id: number) => `/api/InventoryTransferBranch/GetInventoryTransferById/${id}`,
    getLinesByTransferId: (id: number) => `/api/InventoryTransferBranch/GetLinesByInventoryTransferId/${id}`,
    save: '/api/InventoryTransferBranch/Save',
  },

  /** Inventory adjustment (line items: items / batches / stock by warehouse) */
  inventoryAdjustment: {
    getAdjustments: (branchId: number, pageNumber: number, pageSize: number) =>
      `/api/InventoryAdjustment/GetAdjustments/${branchId}/${pageNumber}/${pageSize}`,
    getAdjustmentById: (id: number) => `/api/InventoryAdjustment/GetAdjustmentById/${id}`,
    getAdjustmentLinesByAdjustmentId: (id: number) => `/api/InventoryAdjustment/GetAdjustmentLinesByAdjustmentId/${id}`,
    save: '/api/InventoryAdjustment',
    getItemsByWarehouse: (whId: number) => `/api/InventoryAdjustment/GetItemsByWarehouse/${whId}`,
    getBatchesByWarehouseAndItem: (whId: number, itemId: number) =>
      `/api/InventoryAdjustment/GetBatchesByWarehouseAndItem?whId=${whId}&itemId=${itemId}`,
    getItemDetails: (whId: number, itemId: number, bId: number) =>
      `/api/InventoryAdjustment/GetItemDetails?whId=${whId}&itemId=${itemId}&bId=${bId}`,
  },

  /** Bonus schemes — items / batches with stock under branch (Swagger: Bonus) */
  inventoryBonus: {
    getAvailableItems: (branchId: number) => `/api/Bonus/GetAvailableItems/${branchId}`,
    getAvailableBatches: (branchId: number, itemId: number) => `/api/Bonus/GetAvailableBatches/${branchId}?itemId=${itemId}`,
    getAll: (branchId: number, pageNumber: number, pageSize: number) => `/api/Bonus/GetAll/${branchId}/${pageNumber}/${pageSize}`,
    getById: (branchId: number, id: number) => `/api/Bonus/GetById/${branchId}/${id}`,
    getLinesByMasterId: (branchId: number, masterId: number) => `/api/Bonus/GetLinesByMasterId/${branchId}/${masterId}`,
    save: '/api/Bonus/Save',
    update: '/api/Bonus/Update',
    delete: (branchId: number, id: number) => `/api/Bonus/${branchId}/${id}`,
  },

  /** Discount schemes — branch-level items/batches (Swagger: Discounts) */
  inventoryDiscount: {
    getAvailableItems: (branchId: number) => `/api/Discounts/GetAvailableItems/${branchId}`,
    getAvailableBatches: (branchId: number, itemId: number) =>
      `/api/Discounts/GetAvailableBatches/${branchId}?itemId=${itemId}`,
    getAll: (branchId: number, pageNumber: number, pageSize: number) => `/api/Discounts/GetAll/${branchId}/${pageNumber}/${pageSize}`,
    getById: (branchId: number, id: number) => `/api/Discounts/GetById/${branchId}/${id}`,
    getLinesByMasterId: (branchId: number, masterId: number) => `/api/Discounts/GetLinesByMasterId/${branchId}/${masterId}`,
    save: '/api/Discounts/Save',
    update: '/api/Discounts/Update',
    delete: (branchId: number, id: number) => `/api/Discounts/${branchId}/${id}`,
  },

  // Inventory - Movements (Inventory Movement form)
  inventoryMovement: {
    getWarehousesByBranchId: (branchId: number) => `/api/InventoryTransfer/GetWarehousesByBranchId?branchId=${branchId}`,
    getAllInventoryTransfers: (pageSize: number, pageNumber: number) =>
      `/api/InventoryTransfer/GetAllInventoryTransfers?pageSize=${pageSize}&pageNumber=${pageNumber}`,
    getById: (id: number) => `/api/InventoryTransfer/GetInventoryTransferById/${id}`,
    getLinesByTransferId: (id: number) => `/api/InventoryTransfer/GetLinesByInventoryTransferId/${id}`,
    getItemsByWarehouse: (whId: number) => `/api/InventoryTransfer/GetItemsByWarehouse/${whId}`,
    getBatchesByWarehouseAndItem: (whId: number, itemId: number) =>
      `/api/InventoryTransfer/GetBatchesByWarehouseAndItem?whId=${whId}&itemId=${itemId}`,
    getItemDetails: (whId: number, itemId: number, bId: number) =>
      `/api/InventoryTransfer/GetItemDetails?whId=${whId}&itemId=${itemId}&bId=${bId}`,
    save: '/api/InventoryTransfer/Save',
    update: '/api/InventoryTransfer/Update',
  },

  /** Unsellable inventory movement (Swagger: InventoryMovement) */
  inventoryUnsellableMovement: {
    save: '/api/InventoryMovement/Save',
    getAll: (branchId: number, pageNumber: number, pageSize: number) =>
      `/api/InventoryMovement/GetAllInventoryMovements/${branchId}/${pageNumber}/${pageSize}`,
    getById: (id: number) => `/api/InventoryMovement/GetInventoryMovementById/${id}`,
  },

  // Inventory - Purchase Orders
  purchaseOrders: {
    getAll: (branchId: number, pageSize: number, pageNumber: number) =>
      `/api/PurchaseOrders/GetAllpurchaseOrder?branchId=${branchId}&pageSize=${pageSize}&pageNumber=${pageNumber}`,
    getById: (id: number) => `/api/PurchaseOrders/GetpurchaseOrderById/${id}`,
    getByOrderId: (orderId: number) => `/api/PurchaseOrders/GetpurchaseOrdersByOrderId/${orderId}`,
    getItemList: '/api/PurchaseOrders/GetItemList',
    getAllTaxRates: '/api/PurchaseOrders/GetAllTaxRates',
    getPaymentTerms: '/api/PurchaseOrders/GetPaymentTerms',
    getAllVendors: (branchId: number) => `/api/PurchaseOrders/GetAllVendors?branchId=${branchId}`,
    getAllWarehouses: (branchId: number) => `/api/PurchaseOrders/GetAllWarehouses?branchId=${branchId}`,
    save: '/api/PurchaseOrders/Save',
    update: '/api/PurchaseOrders/Update',
  },

  /** Goods Receipt Note (GRN) */
  grn: {
    getAllGrn: (branchId: number, pageSize: number, pageNumber: number) =>
      `/api/Grn/GetAllGrn?branchId=${branchId}&pageSize=${pageSize}&pageNumber=${pageNumber}`,
    getAllVendors: '/api/Grn/GetAllVendors',
    getOrdersByVendor: (vendorId: number) => `/api/Grn/GetOrders/${vendorId}`,
    getAllWarehouses: (branchId: number) => `/api/Grn/GetAllWarehouses?branchId=${branchId}`,
    getAllTaxRates: '/api/Grn/GetAllTaxRates',
    getOrderLines: (orderId: number) => `/api/Grn/GetOrderLines/${orderId}`,
    getBatches: (whId: number, itemId: number, orderId: number) => `/api/Grn/GetBatches?whId=${whId}&itemId=${itemId}&orderId=${orderId}`,
    getGrnById: (id: number) => `/api/Grn/GetGrnById/${id}`,
    getGrnLinesByGrnId: (id: number) => `/api/Grn/GetGrnLinesByGrnId/${id}`,
    save: '/api/Grn/Save',
    update: '/api/Grn/Update',
    delete: (id: number) => `/api/Grn/Delete/${id}`,
    combinedBill: '/api/Grn/CombinedBill',
    convertToBill: (id: number) => `/api/Grn/ConvertToBill/${id}`,
  },

  /** Goods Return Note — lookups (GRN list for returns, vendors & warehouses for branch) */
  goodsReturns: {
    getAllGoodsReturns: (branchId: number, pageSize: number, pageNumber: number) =>
      `/api/GoodsReturns/GetAllGoodsReturns?branchId=${branchId}&pageSize=${pageSize}&pageNumber=${pageNumber}`,
    getGoodsReturnById: (id: number) => `/api/GoodsReturns/GetGoodsReturnById/${id}`,
    getGoodsReturnLinesByReturnId: (id: number) => `/api/GoodsReturns/GetGoodsReturnLinesByReturnId/${id}`,
    getGrns: (branchId: number) => `/api/GoodsReturns/GetGrns/${branchId}`,
    getGrnLines: (grnId: number) => `/api/GoodsReturns/GetGrnLines/${grnId}`,
    getAllVendors: (branchId: number) => `/api/GoodsReturns/GetAllVendors?branchId=${branchId}`,
    getAllWarehouses: (branchId: number) => `/api/GoodsReturns/GetAllwarehouses?branchId=${branchId}`,
    getAllTaxRates: '/api/GoodsReturns/GetAllTaxRates',
    save: '/api/GoodsReturns/Save',
    update: '/api/GoodsReturns/Update',
    delete: (id: number) => `/api/GoodsReturns/Delete/${id}`,
    combinedRefund: '/api/GoodsReturns/CombinedRefund',
    convertToRefund: (id: number) => `/api/GoodsReturns/ConvertToRefund/${id}`,
  },

  // Inventory - Sales Orders (Swagger: branchId, pageSize, pageNumber query)
  salesOrders: {
    getAllSalesOrders: (branchId: number, pageSize: number, pageNumber: number) =>
      `/api/SalesOrders/GetAllSalesOrders?branchId=${branchId}&pageSize=${pageSize}&pageNumber=${pageNumber}`,
    getSalesOrderById: (id: number) => `/api/SalesOrders/GetSalesOrderById/${id}`,
    getSalesOrderLinesByOrderId: (orderId: number) => `/api/SalesOrders/GetSalesOrderLinesByOrderId/${orderId}`,
    getAllCustomers: (branchId: number) => `/api/SalesOrders/GetAllCustomers?branchId=${branchId}`,
    getWarehouses: (branchId: number) => `/api/SalesOrders/Getwarehouse?branchId=${branchId}`,
    getAllItems: (branchId: number) => `/api/SalesOrders/GetAllItems?branchId=${branchId}`,
    getAllTaxRates: '/api/SalesOrders/GetAllTaxRates',
    getBatches: (branchId: number, itemId: number) => `/api/SalesOrders/GetBatches?branchId=${branchId}&itemId=${itemId}`,
    getWarehouseItems: (whId: number, batchId: number, itemId: number) =>
      `/api/SalesOrders/GetwarehouseItems?whId=${whId}&batchId=${batchId}&itemId=${itemId}`,
    getPaymentTerms: '/api/SalesOrders/GetlookuppaymentTerms',
    getPaymentMethods: '/api/SalesOrders/GetlookuppaymentMethods',
    getDiscountPackages: (params: { itemId: number; branchId: number; orderDate: string }) => {
      const q = new URLSearchParams()
      q.set('itemId', String(params.itemId))
      q.set('branchId', String(params.branchId))
      q.set('orderDate', params.orderDate)
      return `/api/SalesOrders/GetDiscountPackages?${q.toString()}`
    },
    save: '/api/SalesOrders/Save',
    update: '/api/SalesOrders/Update',
  },

  // Delivery Challan (Swagger: /api/Dc/...)
  dc: {
    getAll: (branchId: number, pageSize: number, pageNumber: number) =>
      `/api/Dc/GetAll?branchId=${branchId}&pageSize=${pageSize}&pageNumber=${pageNumber}`,
    getCustomers: (branchId: number) => `/api/Dc/GetCustomers?branchId=${branchId}`,
    getOrders: (branchId: number, customerId: number) => `/api/Dc/GetOrders?branchId=${branchId}&customerId=${customerId}`,
    getOrderLines: (orderId: number) => `/api/Dc/GetOrderLines?orderId=${orderId}`,
    getById: (id: number) => `/api/Dc/GetById?id=${id}`,
    getDcLinesByDcId: (dcId: number) => `/api/Dc/GetDcLinesByDcId?dcId=${dcId}`,
    save: '/api/Dc/Save',
    update: '/api/Dc/Update',
    convertToInvoice: (dcId: number) => `/api/Dc/ConvertToInvoice?dcId=${dcId}`,
    /** POST JSON body: `number[]` — delivery challan ids */
    multipleInvoices: '/api/Dc/MultipleInvoices',
  },

  // Inventory - Sales Quotation (Swagger: /api/SalesQuotation/...)
  salesQuotation: {
    getAllCustomers: (branchId: number) => `/api/SalesQuotation/GetAllCustomers?branchId=${branchId}`,
    getWarehouses: (branchId: number) => `/api/SalesQuotation/GetWarehouses?branchId=${branchId}`,
    paymentMethods: '/api/SalesQuotation/PaymentMethods',
    paymentTerms: '/api/SalesQuotation/PaymentTerms',
    getAllItems: (branchId: number) => `/api/SalesQuotation/GetAllItems?branchId=${branchId}`,
    getAllWarehouseItems: '/api/SalesQuotation/GetAllWarehouseItems',
    getItemsByWarehouse: (warehouseId: number) => `/api/SalesQuotation/GetItemsByWarehouse/${warehouseId}`,
    getAllTaxRates: '/api/SalesQuotation/GetAllTaxRates',
    getBatchesByWarehouseAndItem: (warehouseId: number, itemId: number) =>
      `/api/SalesQuotation/GetBatchesByWarehouseAndItem?warehouseId=${warehouseId}&itemId=${itemId}`,
    getItemDetails: (warehouseId: number, itemId: number, batchId: number) =>
      `/api/SalesQuotation/GetItemDetails?warehouseId=${warehouseId}&itemId=${itemId}&batchId=${batchId}`,
    getAllSalesQuotations: (branchId: number, pageSize: number, pageNumber: number) =>
      `/api/SalesQuotation/GetAllSalesQuotations?branchId=${branchId}&pageSize=${pageSize}&pageNumber=${pageNumber}`,
    getSalesQuotationById: (id: number) => `/api/SalesQuotation/GetSalesQuotationById/${id}`,
    getSalesQuotationLinesById: (id: number) => `/api/SalesQuotation/GetSalesQuotationLinesById/${id}`,
    save: '/api/SalesQuotation/Save',
    update: '/api/SalesQuotation/Update',
    convertToOrder: (id: number) => `/api/SalesQuotation/ConvertToOrder/${id}`,
    combinedConvertToOrder: '/api/SalesQuotation/CombinedConvertToOrder',
    delete: (id: number) => `/api/SalesQuotation/Delete/${id}`,
  },

  // POS
  pos: {
    /** Swagger: GET /api/Pos/GetItemByBarcode?branchId=1&barcode=...&orderDate=YYYY-MM-DD */
    getItemByBarcode: (params: { branchId: number; barcode: string; orderDate: string }) => {
      const q = new URLSearchParams()
      q.set('branchId', String(params.branchId))
      q.set('barcode', params.barcode)
      q.set('orderDate', params.orderDate)
      return `/api/Pos/GetItemByBarcode?${q.toString()}`
    },
    /** Swagger: GET /api/Pos/GetBanks?branchId=1 */
    getBanks: (branchId: number) => `/api/Pos/GetBanks?branchId=${branchId}`,
    /** Swagger: POST /api/Pos/Save */
    save: '/api/Pos/Save',
  },
} as const

